import request from '../util/wwwrequest'
// 获取百科列表
export function getVatList(params){
    return request.get(`/api/ipr/api/iprSchool/catalogueList/${params}`)
}

// 获取百科全部数据
export function getVat(params){
    return request.get('/api/ipr/api/iprSchool/news/list',params)
}

// 获取百科全部数据
export function getVatDetail(params){
    return request.get('/api/ipr/api/iprSchool/news/details',params)
}

// 获取百科详情页 的上一页，下一页
export function afterAndLast(params){
    return request.get('/vat/ost/detailBeforeAfter',params)
}


// WEBPACK FOOTER //
// ./src/api/VAT.js